import { render } from "./resetPswModal.vue?vue&type=template&id=4bf90b40&ts=true"
import script from "./resetPswModal.vue?vue&type=script&lang=ts"
export * from "./resetPswModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__